import { message as messageService } from 'antd';
import { MessageType } from 'antd/lib/message';
import { successGreen, errorRed, cross } from '@rootCommon/images';

messageService.config({
  duration: 3,
  maxCount: 10,
  top: 10,
});

type MessageTemplateProps = {
  message: string;
  subMessage?: string;
  title?: string;
};

const MessageTemplate = ({ message, subMessage, title }: MessageTemplateProps): JSX.Element => (
  <div>
    {title && <div className="message-title">{title}</div>}
    <div className="message-text">{message}</div>
    {subMessage && <div className="message-submessage">{subMessage}</div>}
    <div className="message-close" onClick={() => messageService.destroy()}>
      <img src={cross} alt="" />
    </div>
  </div>
);

export default class Message {
  public static config(configData = {}): void {
    messageService.config(configData);
  }

  public static success(message: string, subMessage?: string, title?: string): MessageType {
    return messageService.success({
      content: (
        <MessageTemplate title={title} subMessage={subMessage} message={message} />
      ),
      icon: <img src={successGreen} alt="" />,
    });
  }

  public static info(message: string, subMessage?: string, title?: string): MessageType {
    return messageService.info({
      content: (
        <MessageTemplate title={title} subMessage={subMessage} message={message} />
      ),
      icon: <></>,
    });
  }

  public static warn(message: string, subMessage?: string, title?: string): MessageType {
    return messageService.warn({
      content: (
        <MessageTemplate title={title} subMessage={subMessage} message={message} />
      ),
      icon: <></>,
    });
  }

  public static error(message: string, subMessage?: string, title?: string): MessageType {
    return messageService.error({
      content: (
        <MessageTemplate title={title} subMessage={subMessage} message={message} />
      ),
      icon: <img src={errorRed} alt="" />,
    });
  }
}
